export const useGMTDataLayer = (data: object): void => {
  const { dataLayer } = window
  if (dataLayer !== undefined) {
    dataLayer.push(data)
  }
}
